<template>
  <div class="container py-3">
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <a-input-search
          placeholder="请输入区域或地址开始查询资产"
          style="width: 50%"
          v-model="address"
          @search="onSearch"
          :allowClear="true"
        />
        <standard-form-row
          title="房源位置"
          block
          style="padding-bottom: 11px; padding-top: 20px"
        >
          <a-form-item style="margin-top: -4px">
            <tag-select v-model="district">
              <tag-select-option value="310116">金山区</tag-select-option>
              <tag-select-option value="OTHER_REGION">
                其他区域
              </tag-select-option>
            </tag-select>
          </a-form-item>
          <a-form-item
            v-if="districtList.includes('310116') && areaList.length > 0"
          >
            <tag-select v-model="town" :key="'town-' + areaList.length">
              <tag-select-option
                v-for="item in areaList"
                :key="item.XZQYDM"
                :value="item.XZQYDM"
              >
                {{ item.XZQYMC }}
              </tag-select-option>
            </tag-select>
          </a-form-item>
        </standard-form-row>

        <standard-form-row title="租赁用途" block style="padding-bottom: 11px">
          <a-form-item
            v-if="leaseUseTypeList.length > 0"
            style="margin-top: -4px"
          >
            <tag-select
              v-model="leaseUseType"
              :key="'leaseUseType-' + leaseUseTypeList.length"
            >
              <tag-select-option
                v-for="item in leaseUseTypeList"
                :key="item.value"
                :value="String(item.value)"
              >
                {{ item.note }}
              </tag-select-option>
            </tag-select>
          </a-form-item>
        </standard-form-row>

        <standard-form-row title="房屋面积" block style="padding-bottom: 11px">
          <a-form-item style="margin-top: -4px">
            <tag-select v-model="floorSpace">
              <tag-select-option value="1">＜100㎡</tag-select-option>
              <tag-select-option value="2">100-300㎡</tag-select-option>
              <tag-select-option value="3">300-500㎡</tag-select-option>
              <tag-select-option value="4">500-1000㎡</tag-select-option>
              <tag-select-option value="5">＞1000㎡</tag-select-option>
            </tag-select>
          </a-form-item>
        </standard-form-row>
      </a-form>
    </a-card>
    <div
      class="container-fluid blog py-2"
      style="margin-top: 30px; margin-bottom: 30px"
    >
      <div
        v-if="spinValue"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          height: 900px;
        "
      >
        <a-spin>
          <a-icon slot="indicator" type="loading" style="font-size: 50px" />
        </a-spin>
      </div>
      <div v-else>
        <div v-if="houseEntity.length !== 0">
          <div
            style="
              display: flex;
              justify-content: center; /* 水平居中 */
              align-items: center; /* 垂直居中 */
            "
          >
            <div style="width: 100%">
              <!-- <p style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    margin-bottom: 12px;
                    ">
            </p> -->
              <HouseItem :houseEntity="houseEntity"></HouseItem>
              <a-pagination
                style="margin-top: 20px; float: right"
                :current="pagination.currentNum"
                :defaultPageSize="12"
                :total="pagination.total"
                @change="onChange"
              />
            </div>
          </div>
        </div>
        <a-empty
          v-else
          :description="false"
          :image-style="{
            height: '400px',
          }"
        >
          <div
            class=""
            style="
              font-size: 18px;
              margin: 4px 20px;
              font-weight: bold;
              color: #101d37;
              font-family: Helvetica;
              display: inline-block;
            "
          >
            暂无房源
          </div>
        </a-empty>
      </div>
    </div>
  </div>
</template>

<script>
import HouseItem from "@/components/property/HouseItem";
import StandardFormRow from "@/components/StandardFormRow";
import TagSelect from "@/components/TagSelect";
import { listProject } from "@/api/publicInfo/PublicInfo.js";
import {
  initAreaListJINSHAN,
  initLeaseUseType,
} from "@/api/shexgrp/InitDictionaries.js";
const TagSelectOption = TagSelect.Option;

export default {
  components: {
    TagSelect,
    TagSelectOption,
    StandardFormRow,
    HouseItem,
  },
  data() {
    return {
      district: {}, //房源位置
      districtList: [],
      town: {}, // 金山区内房源位置（子数据）
      townList: [],
      floorSpace: {}, //房屋面积
      floorSpaceList: [],
      address: "",
      houseEntity: [],
      pagination: {
        currentNum: 1,
        total: 1,
      },
      indicator: <a-icon type="loading" style="font-size: 24px" spin />,
      spinValue: true,
      // 金山行政区划字典
      areaLoading: false,
      areaList: [],
      // 租赁用途字典
      leaseUseTypeLoading: false,
      leaseUseTypeList: [],

      // 租赁用途筛选
      leaseUseType: {},
      leaseUseTypeSelectedList: [],
    };
  },
  mounted() {
    this.initAreaVisible();
    this.initLeaseUseTypeVisible();
    this.searchHouse();
  },
  watch: {
    district(newVal) {
      this.pagination.currentNum = 1;

      this.districtList = this.screen(newVal, this.districtList, [
        "310116",
        "OTHER_REGION",
      ]);

      this.searchHouse();
    },
    town(newVal) {
      this.pagination.currentNum = 1;

      const initList = this.areaList.map((item) => item.XZQYDM);

      this.townList = this.screen(newVal, this.townList, initList);

      this.searchHouse();
    },
    leaseUseType(newVal) {
      this.pagination.currentNum = 1;

      const initList = this.leaseUseTypeList.map((item) => String(item.value));

      this.leaseUseTypeSelectedList = this.screen(
        newVal,
        this.leaseUseTypeSelectedList,
        initList
      );

      this.searchHouse();
    },
    floorSpace(newVal) {
      this.pagination.currentNum = 1;
      this.floorSpaceList = this.screen(newVal, this.floorSpaceList, [
        "1",
        "2",
        "3",
        "4",
        "5",
      ]);
      this.searchHouse();
    },
  },
  methods: {
    // 用于多选框的参数筛选
    screen(newVal, parmList, initList) {
      let list = Array.isArray(parmList) ? [...parmList] : [];

      if (!newVal || newVal.value === undefined) {
        return list;
      }

      const value = newVal.value;

      // 点击“不限”
      if (value === "total") {
        return newVal.checked ? [...initList] : [];
      }

      // 如果当前已经是全选状态，再点击具体项，说明用户想从“不限”切换到单项
      const isAllSelected =
        initList.length > 0 &&
        list.length === initList.length &&
        initList.every((item) => list.includes(item));

      if (newVal.checked === true) {
        if (isAllSelected) {
          list = [value];
        } else if (!list.includes(value)) {
          list.push(value);
        }
      }

      if (newVal.checked === false) {
        list = list.filter((item) => item !== value);
      }

      // 去重，防止重复编码
      return [...new Set(list)];
    },

    // 查询房源
    searchHouse() {
      this.spinValue = true;

      const queryParam = {
        bizType: 2,

        address: this.address,

        includeJinshan: this.districtList.includes("310116"),

        includeOtherRegion: this.districtList.includes("OTHER_REGION"),

        regionCodeList: this.townList,

        leaseUseType: this.leaseUseTypeSelectedList,

        floorSpaceList: this.floorSpaceList,

        page: this.pagination.currentNum,

        pageSize: 12,
      };

      // 调试阶段建议保留
      console.log("房源查询条件：", queryParam);

      listProject(queryParam)
        .then((res) => {
          if (res && res.code === "200") {
            this.houseEntity = res.data || [];

            this.pagination.currentNum = res.pageNo || 1;

            this.pagination.total = res.total || 0;
          }
        })
        .catch((err) => {
          console.error("查询房源失败", err);
        })
        .finally(() => {
          this.spinValue = false;
        });
    },
    onSearch() {
      this.pagination.currentNum = 1;
      this.searchHouse();
    },
    onChange(current) {
      this.pagination.currentNum = current;
      this.searchHouse();
    },
    /**
     * 初始化金山行政区划字典
     */
    async loadAreaList(apiFn, errorMsg) {
      // 已加载过直接返回
      if (this.areaList.length > 0) {
        return;
      }

      // 防止重复请求
      if (this.areaLoading) {
        return;
      }

      this.areaLoading = true;

      try {
        const res = await apiFn();

        if (!res || res.code !== "200") {
          this.areaList = [];
          return;
        }

        this.areaList = res.data || [];
      } catch (e) {
        console.error(errorMsg, e);

        // 加载失败时置空
        this.areaList = [];
      } finally {
        this.areaLoading = false;
      }
    },
    /**
     * 初始化金山行政区划字典
     */
    initAreaVisible() {
      return this.loadAreaList(initAreaListJINSHAN, "行政区划初始化失败");
    },

    /**
     * 初始化租赁用途字典
     */
    async loadLeaseUseTypeList(apiFn, errorMsg) {
      // 已加载过直接返回
      if (this.leaseUseTypeList.length > 0) {
        return;
      }

      // 防止重复请求
      if (this.leaseUseTypeLoading) {
        return;
      }

      this.leaseUseTypeLoading = true;

      try {
        const res = await apiFn();

        if (!res || res.code !== "200") {
          this.leaseUseTypeList = [];
          return;
        }

        this.leaseUseTypeList = res.data || [];
      } catch (e) {
        console.error(errorMsg, e);

        // 加载失败时置空
        this.leaseUseTypeList = [];
      } finally {
        this.leaseUseTypeLoading = false;
      }
    },

    /**
     * 初始化租赁用途字典
     */
    initLeaseUseTypeVisible() {
      return this.loadLeaseUseTypeList(
        initLeaseUseType,
        "租赁用途字典初始化失败"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.ant-pro-components-tag-select {
  /deep/ .ant-pro-tag-select .ant-tag {
    margin-right: 24px;
    padding: 0 8px;
    font-size: 14px;
  }
}

.list-articles-trigger {
  margin-left: 12px;
}
</style>